import { ErrorHandler, Provider, APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SentryHttpInterceptor } from '../sentry-http.interceptor';

export interface SentryProviderOptions {
  showErrorDialog?: boolean;
  logErrors?: boolean;
}

export function provideSentry(
  options: SentryProviderOptions = {}
): Provider[] {
  const { showErrorDialog = false, logErrors = true } = options;

  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: showErrorDialog,
        logErrors
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SentryHttpInterceptor,
      multi: true
    }
  ];
}
